export default "__VITE_ASSET__thf76d3q__"